import React,{useEffect} from 'react'

import Banner from "./../Component/About/Banner"
import Ab2 from "./../Component/About/Ab2.js"
import Ab1 from "./../Component/About/Ab1.js"
import Dna from "./../Component/About/Dna"
import Wmd from "./../Component/About/Wmd"
import Oc from "./../Component/About/Oc"
import Tm from "./../Component/About/Testimonials"
import Tm2 from "./../Component/About/Testimonials2"
import Counter from "./../Component/About/Counter.js"


const About = () => {
useEffect(() => {
  window.scrollTo(0, 0);

  // About Page Meta Tags
  document.title = 'Rushikesh Career Guidance: About Us | Get In Touch With Our Expert Counsellors';

  // Set meta description dynamically
  const aboutMetaDescription = document.createElement('meta');
  aboutMetaDescription.name = 'description';
  aboutMetaDescription.content = 'Expert guidance for medical and engineering aspirants with personalised counselling, smart college selection, and complete admission support.';
  document.head.appendChild(aboutMetaDescription);

  // Set meta keywords dynamically
  const aboutMetaKeywords = document.createElement('meta');
  aboutMetaKeywords.name = 'keywords';
  aboutMetaKeywords.content = 'NEET counselling near me, NEET admission counselling near me, NEET counsellor near me ,Medical admission guidance near me, NEET guidance center near me, Best NEET counsellor near me, NEET career guidance near me, MBBS admission counsellor near me, Medical college admission help near me, Maharashtra NEET counselling, Maharashtra MBBS admission guidance, State quota NEET counselling Maharashtra, NEET Maharashtra counselling expert, Maharashtra medical admission consultant,Private medical college admission Maharashtra, Government medical college admission guidance, RCG, RCG Counseling, Rushikesh Career Guidance';
  document.head.appendChild(aboutMetaKeywords);

  // Set canonical link dynamically
  const aboutCanonicalLink = document.createElement('link');
  aboutCanonicalLink.rel = 'canonical';
  aboutCanonicalLink.href = 'https://rcgcounselling.com/about';
  document.head.appendChild(aboutCanonicalLink);

  // Set Open Graph title dynamically
  const aboutOgTitle = document.createElement('meta');
  aboutOgTitle.property = 'og:title';
  aboutOgTitle.content = 'Rushikesh Career Guidance: About Us | Get In Touch With Our Expert Counsellors';
  document.head.appendChild(aboutOgTitle);

  // Set Open Graph description dynamically
  const aboutOgDescription = document.createElement('meta');
  aboutOgDescription.property = 'og:description';
  aboutOgDescription.content = 'Expert guidance for medical and engineering aspirants with personalised counselling, smart college selection, and complete admission support.';
  document.head.appendChild(aboutOgDescription);

  // Set Open Graph URL dynamically
  const aboutOgUrl = document.createElement('meta');
  aboutOgUrl.property = 'og:url';
  aboutOgUrl.content = 'https://rcgcounselling.com/about';
  document.head.appendChild(aboutOgUrl);

  // Set Open Graph site name dynamically
  const aboutOgSiteName = document.createElement('meta');
  aboutOgSiteName.property = 'og:site_name';
  aboutOgSiteName.content = 'Rushikesh Career Guidance';
  document.head.appendChild(aboutOgSiteName);

  // Set Open Graph image dynamically
  const aboutOgImage = document.createElement('meta');
  aboutOgImage.property = 'og:image';
  aboutOgImage.content = 'https://rcgcounselling.com/g1.jpg';
  document.head.appendChild(aboutOgImage);

  // Set Open Graph secure image URL dynamically
  const aboutOgImageSecure = document.createElement('meta');
  aboutOgImageSecure.property = 'og:image:secure_url';
  aboutOgImageSecure.content = 'https://rcgcounselling.com/g1.jpg';
  document.head.appendChild(aboutOgImageSecure);

  // Set Open Graph image width dynamically
  const aboutOgImageWidth = document.createElement('meta');
  aboutOgImageWidth.property = 'og:image:width';
  aboutOgImageWidth.content = '300';
  document.head.appendChild(aboutOgImageWidth);

  // Set Open Graph image height dynamically
  const aboutOgImageHeight = document.createElement('meta');
  aboutOgImageHeight.property = 'og:image:height';
  aboutOgImageHeight.content = '200';
  document.head.appendChild(aboutOgImageHeight);

  // Cleanup on component unmount

   // Add Structured Data for About Page
    const aboutStructuredData = document.createElement('script');
    aboutStructuredData.type = 'application/ld+json';
    aboutStructuredData.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "url": "https://rcgcounselling.com/about",
      "name": "Rushikesh Career Guidance",
      "description": " Get In Touch With Our Expert Counsellors",
      "publisher": {
        "@type": "Organization",
        "name": "Rushikesh Career Guidance",
          "telephone": "+917620582520",
              "contactType": "customer service",
               "areaServed": "IN",
                "availableLanguage": ["English", "Marathi", "Hindi"],
          
        "logo": {
          "@type": "ImageObject",
          "url": "https://rcgcounselling.com/g1.jpg"
        },
        "description": "Expert guidance for medical and engineering aspirants with personalised counselling, smart college selection, and complete admission support.",
  "inLanguage": "en",
    "sitelinks": [
    {
      "@type": "WebPage",
      "name": "Home",
      "url": "https://rcgcounselling.com"
    },
    {
      "@type": "WebPage",
      "name": "Services",
      "url": "https://rcgcounselling.com/service"
    },
    {
      "@type": "WebPage",
      "name": "About Us",
      "url": "https://rcgcounselling.com/about"
    },
            {
      "@type": "WebPage",
      "name": "Portfolio",
      "url": "https://rcgcounselling.com/portfolio"
    },
    {
      "@type": "WebPage",
      "name": "Contact",
      "url": "https://rcgcounselling.com/Contact"
    }
  ]
      }
    });
    document.head.appendChild(aboutStructuredData);


  return () => {
    document.title = 'Rushikesh Career Guidance: About Us | Get In Touch With Our Expert Counsellors';
    document.head.removeChild(aboutMetaDescription);
    document.head.removeChild(aboutMetaKeywords);
    document.head.removeChild(aboutCanonicalLink);
    document.head.removeChild(aboutOgTitle);
    document.head.removeChild(aboutOgDescription);
    document.head.removeChild(aboutOgUrl);
    document.head.removeChild(aboutOgSiteName);
    document.head.removeChild(aboutOgImage);
    document.head.removeChild(aboutOgImageSecure);
    document.head.removeChild(aboutOgImageWidth);
    document.head.removeChild(aboutOgImageHeight);
        document.head.removeChild(aboutStructuredData);
  };

}, []);

  return (
    <div>

<Banner/>
{/*<Ab1/>*/}

<Dna/>
<Wmd/>

<Counter/>
<Tm/>
<Tm2/>
{/*<Oc/>*/}
<Ab2/>


    </div>
  )
}

export default About